export default __webpack_public_path__ + "static/media/destination.5336278d.svg";